import {Component} from 'react';
import injectSheet from 'react-jss';

import globalStyles from '-/styles/global';

const styles = theme => ({
    ...globalStyles(theme)
});

class Normalize extends Component {
    render() {
        return <div />;
    }
}

export default injectSheet(styles)(Normalize);
